import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export const TabContainerStyled = styled.div({
  display: 'flex',
  borderBottom: `2px solid ${hexColors.studio}`,
  marginBottom: '1rem',
})

export const TabButtonStyled = styled.button<{ active: boolean }>(({ active }) => ({
  padding: '0.75rem 1.5rem',
  border: 'none',
  backgroundColor: active ? hexColors.studio : 'transparent',
  color: active ? 'white' : hexColors.studio,
  cursor: 'pointer',
  borderRadius: '4px 4px 0 0',
  fontWeight: active ? 'bold' : 'normal',
}))

export const TabContentStyled = styled.div({
  minHeight: '200px',
})

export const MessageStyled = styled.div({
  padding: '1.5rem',
  textAlign: 'center',
  fontSize: '1.6rem',
  fontWeight: '600',
  color: hexColors.studio,
})

export const OffersWrapperStyled = styled.div({
  position: 'relative',
})

export const OffersContentStyled = styled.div<{ disabled: boolean }>(({ disabled }) => ({
  opacity: disabled ? 0.5 : 1,
  transition: 'opacity 0.3s ease',
}))

export const DisabledOverlayStyled = styled.div({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(230, 230, 230, 0.2)',
  zIndex: 2,
  cursor: 'not-allowed',
})
